/*
 * File: app-slice.ts
 * Project: receiving-rules
 * -----
 * Last Modified: 30 Sep 2020 5:38:56 pm
 * -----
 * Copyright (c) 2020 Elegant Software Solutions All rights reserved.
 */

import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { AppState } from '@auth0/auth0-react';
import { AcuityContextModel } from 'models/AcuityContextModel';
import { UserModel } from 'models/UserModel';
import { AppStateModel } from '../../models/AppStateModel';

const initialState: AppStateModel = {
  isAltIdCellLoading: false,
  application: null,
  user: null,
  acuityContext: null,
  accessToken: null,
  selectedCustomerAccount: undefined,
  customerData: undefined,
  firstChunkNumber: 100,
  secondChunkNumber: 200,
};

export const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setIsAltIdCellLoading(state, action: PayloadAction<boolean>): void {
      state.isAltIdCellLoading = action.payload;
    },
    setUser(state, action: PayloadAction<UserModel>): void {
      state.user = action.payload;
    },
    setAcuityContext(state, action: PayloadAction<AcuityContextModel>): void {
      state.acuityContext = action.payload;
    },
    setAccessToken(state, action: PayloadAction<string>) {
      state.accessToken = action.payload;
    },
    setSelectedCustomerAccount(state, action: PayloadAction<string>) {
      state.selectedCustomerAccount = action.payload;
    },
    setCustomerData(state, { payload }: PayloadAction<AppState['customerData']>) {
      state.customerData = payload;
    },
    setFirstChunkNumber(state, { payload }: PayloadAction<AppState['firstChunkNumber']>) {
      state.firstChunkNumber = payload;
    },
    setSecondChunkNumber(state, { payload }: PayloadAction<AppState['secondChunkNumber']>) {
      state.secondChunkNumber = payload;
    },
    increaseFirstChunkNumber(state) {
      state.firstChunkNumber += 100;
    },
    increaseSecondChunkNumber(state) {
      state.secondChunkNumber += 100;
    },
  }
});

export const { setIsAltIdCellLoading, setUser, setAcuityContext, setAccessToken, setSelectedCustomerAccount, setCustomerData, setFirstChunkNumber, setSecondChunkNumber, increaseFirstChunkNumber, increaseSecondChunkNumber } = appSlice.actions;

export const appReducer = appSlice.reducer;
